import {Suspense} from 'react'
import {ActionList} from '@primer/react'
import {clsx} from 'clsx'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'

import {ActivityLoading} from './ActivityLoading'
import {ActivityError} from './ActivityError'
import {useSuspenseActivityPageData} from '../data/use-activity-page-data'
import {hasSidebarActivity} from './rows/activity-row-helpers'
import sidebarListStyles from '../SidebarActionList.module.css'
import {CommitsRow} from './rows/CommitsRow'
import {BaseForceRow} from './rows/BaseForceRow'
import {ApprovedRow} from './rows/ApprovedRow'
import {ChangesRequestedRow} from './rows/ChangesRequestedRow'
import {ReviewCommentsRow} from './rows/ReviewCommentsRow'
import {IssueCommentsRow} from './rows/IssueCommentsRow'
import {StateRow} from './rows/StateRow'
import {ReviewRequestsRow} from './rows/ReviewRequestsRow'
import {FullTimelineLink} from './rows/FullTimelineLink'

export function SidebarActivity() {
  return (
    <ErrorBoundary boundaryName="SidebarActivity" fallback={<ActivityError />}>
      <Suspense fallback={<ActivityLoading />}>
        <SidebarActivityContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function SidebarActivityContent() {
  const {summary} = useSuspenseActivityPageData()

  return (
    <div className="d-flex flex-column">
      {hasSidebarActivity(summary) ? (
        <ActionList variant="full" className={clsx(sidebarListStyles.flush, sidebarListStyles.compact)}>
          <CommitsRow />
          <BaseForceRow />
          <ApprovedRow />
          <ChangesRequestedRow />
          <ReviewCommentsRow />
          <IssueCommentsRow />
          <StateRow />
          <ReviewRequestsRow />
        </ActionList>
      ) : (
        <p className="color-fg-muted mb-0">No activity yet</p>
      )}
      <FullTimelineLink />
    </div>
  )
}
